module.exports = __webpack_public_path__ + "img/entertainment-4.ee75c332.jpg";